"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SvgFilePdf = function SvgFilePdf(props) {
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], props, /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("style", null, '.file_pdf_svg__cls-1{fill:#333}')), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.68 13.79a5.14 5.14 0 00-1.64.37 5.76 5.76 0 01-.61-.6 3.83 3.83 0 01-.36-.44c.93-2.07-.07-2.33-.07-2.33a3.86 3.86 0 01-.31 1.64 3.66 3.66 0 01-.26-2.66c.59-.17.72.9.72.9a.86.86 0 00-.35-1.17l-.15-.06c-1.21-.47-1.27 1.8-.23 3.65a17.1 17.1 0 01-2.81 4.09c-.26.28-.12-1 1-1.44 0 0-2 .2-1.66 1.71.25 1.19 1.42.2 2.74-1.83a19.69 19.69 0 012.23-.79c1.59 1.35 3 1.26 3.11.37a3.4 3.4 0 01-2.3-.55c1.09-.2 2.08-.13 2.41.61a1.4 1.4 0 00-1.33-1.47zM11 15.05l.55-.94.22-.41.23.3c.13.15.27.3.41.44-.51.18-1 .42-1.41.61z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none",
    id: "file_pdf_svg__Bounding_Boxes",
    "data-name": "Bounding Boxes"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8zm4 18H6V4h7v5h5z",
    id: "file_pdf_svg__Outline"
  }));
};

var _default = SvgFilePdf;
exports["default"] = _default;